// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Jo-z","breadcrumbForward":"Ko-z","breadcrumbBack":"Lo-z","selected":"Mo-z"};